import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Input,
  InputGroup,
  InputRightAddon,
  Text,
} from '@chakra-ui/core';
import { ChevronRightIcon, CopyIcon } from '@chakra-ui/icons';
import copy from 'copy-to-clipboard';
import React, { useState } from 'react';
import PreviewOfferImage from '../../assets/preview_offer.png';
import MailchimpForm from '../../components/MailchimpForm';

const NewBetLink = ({ onNext, betId, pubkey }) => {
  const betUrl = `https://atomic.finance/odds/app/offer/${betId}`;
  const [mailchimpModalOpen, setMailchimpModalOpen] = useState(
    !window.localStorage.getItem('mailchimpSet')
  );

  return (
    <>
      <Flex flexDir="column" alignItems="center">
        <Heading as="h3" textAlign="center" mb={2}>
          Congratulations!
        </Heading>
        <Text fontWeight="500">
          Your bet offer is now live and ready to be shared!
        </Text>

        <Box
          position="relative"
          borderRadius="8px"
          overflow="hidden"
          w="300px"
          h="170px"
          my={4}
        >
          <Flex
            alignItems="center"
            justifyContent="center"
            position="absolute"
            top={0}
            cursor="pointer"
            onClick={() => window.open(`/odds/app/offer/${betId}`)}
            left={0}
            boxSize="full"
          >
            <Text
              color="white"
              fontWeight="bold"
              zIndex="0"
              pointerEvents="none"
            >
              Preview Bet Page
            </Text>
            <Box
              position="absolute"
              transition="opacity 0.1s linear"
              _hover={{
                opacity: 0.7,
              }}
              opacity="0.57"
              bg="#000000"
              boxSize="full"
            />
          </Flex>
          <Image src={PreviewOfferImage} />
        </Box>
        <Text fontWeight="500" mb={2}>
          Spread the word! Publicize your bet using this link:
        </Text>

        <InputGroup w="fit-content">
          <Input isReadOnly w="350px" value={betUrl} />

          <InputRightAddon
            cursor="pointer"
            onClick={() => copy(betUrl)}
            bg="blue.600"
            children={<CopyIcon color="white" />}
            transition="opacity 0.1s linear"
            _hover={{ opacity: 0.75 }}
          />
        </InputGroup>

        <Text fontSize="xs" mt={2}>
          You can also find this bet under the "Active Offers" tab on your
          Dashboard
        </Text>
      </Flex>
      <Flex flexDir="row" mt={8}>
        <Button
          ml="auto"
          colorScheme="blue"
          rightIcon={<ChevronRightIcon />}
          onClick={onNext}
        >
          Go to Dashboard
        </Button>
      </Flex>
      <MailchimpForm
        mailchimpFormOpen={mailchimpModalOpen}
        twitterName={''}
        onNext={() => setMailchimpModalOpen(false)}
        staticPubkey={pubkey}
      />
    </>
  );
};

export default NewBetLink;
